import { View } from "react-native";
import { CardSurface, MoonSkeleton } from "@louise/moon-ui";
import { semanticColors } from "@louise/theme/tokens";

function SkeletonRow({ isFirst = false }: { isFirst?: boolean }) {
  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        paddingHorizontal: 16,
        paddingVertical: 14,
        borderTopWidth: isFirst ? 0 : 1,
        borderTopColor: semanticColors.border.default,
        gap: 14,
      }}
    >
      <MoonSkeleton width={28} height={28} circle />
      <MoonSkeleton width={120} height={15} style={{ flex: 1 }} />
      <MoonSkeleton width={60} height={14} />
    </View>
  );
}

export default function YouScreenSkeleton() {
  return (
    <View
      testID="screen-loading"
      style={{ paddingHorizontal: 20, paddingTop: 52, gap: 20 }}
    >
      {/* Avatar placeholder */}
      <View style={{ alignItems: "center", marginBottom: 8 }}>
        <MoonSkeleton width={80} height={80} circle />
        <MoonSkeleton
          width={140}
          height={20}
          radius={8}
          style={{ marginTop: 12 }}
        />
        <MoonSkeleton width={100} height={14} style={{ marginTop: 6 }} />
      </View>

      {/* Passport section */}
      <View>
        <MoonSkeleton width={100} height={11} style={{ marginBottom: 12 }} />
        <CardSurface style={{ padding: 16, flexDirection: "row", gap: 14 }}>
          {[1, 2, 3, 4].map((i) => (
            <MoonSkeleton key={i} width={56} height={56} circle />
          ))}
        </CardSurface>
      </View>

      {/* Your Info section */}
      <View>
        <MoonSkeleton width={80} height={11} style={{ marginBottom: 12 }} />
        <CardSurface>
          <SkeletonRow isFirst />
          <SkeletonRow />
          <SkeletonRow />
          <SkeletonRow />
          <SkeletonRow />
        </CardSurface>
      </View>

      {/* Settings section */}
      <View>
        <MoonSkeleton width={70} height={11} style={{ marginBottom: 12 }} />
        <CardSurface>
          <SkeletonRow isFirst />
          <SkeletonRow />
          <SkeletonRow />
          <SkeletonRow />
        </CardSurface>
      </View>
    </View>
  );
}
